// Design System 2.0 (2026-10, Phase 1) — the ONE open-section primitive: 11px label over a
// 1px ink rule, rows on hairlines. Generalizes the ~4 near-identical local `Section` consts
// that currently live separately inside ProjectDashboard.jsx / Clients.jsx / PartnerDetail.jsx.
// New, unused by any page yet — page-level swaps happen in their own phases.
export function Section({ title, action, children, testId }) {
  return (
    <section data-testid={testId}>
      <header className="flex items-center justify-between border-b border-ink pb-1.5 mb-3">
        <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-ink-soft">{title}</span>
        {action}
      </header>
      {children}
    </section>
  );
}

/** Cards only when the container has a job (live synced data, a permission boundary, a board
 * column, a table, a stat) — SectionPanel is that bounded-container variant. */
export function SectionPanel({ title, action, children, testId }) {
  return (
    <section className="rounded-md border border-hairline bg-paper" data-testid={testId}>
      <header className="border-b border-hairline px-4 py-3 flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-faint">{title}</span>
        {action}
      </header>
      {children}
    </section>
  );
}
